export enum LAYOUTS {
  DEFAULT = 'Default',
  ADMIN = 'Admin',
}
